// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b94e98ff","453":"578443e8","455":"3b636b16"}[chunkId] + ".chunk.js";
};